import { render } from "./HeadMessage.vue?vue&type=template&id=732d418e"
import script from "./HeadMessage.vue?vue&type=script&lang=js"
export * from "./HeadMessage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__